import './App.css';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { StyleContextProvider } from './providers/StyleContextProvider';
import { AuthContextProvider } from './providers/AuthContextProvider';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { WhatsAppPage } from './pages/WhatsAppPage';
import { AdListPage } from './pages/tuition/AdListPage';
import { NewAdsPage } from './pages/tuition/NewAdPage';
import { AdEditPage } from './pages/tuition/AdEditPage';
import { useEffect } from 'react';
import { PaymentsPage } from './pages/PaymentsPage';
import { OnlineClassWeeksPage } from './pages/online-classes/OnlineClassWeeksPage';
import { StateDegreeListPage } from './pages/degrees/StateDegreeListPage';
import { StateDegreeEditPage } from './pages/degrees/StateDegreeEditPage';
import { PrivateDegreeListPage } from './pages/degrees/PrivateDegreeListPage';
import { PrivateDegreeEditPage } from './pages/degrees/PrivateDegreeEditPage';  
import { StateDiplomaListPage } from './pages/diplomas/StateDiplomaListPage';
import { StateDiplomaEditPage } from './pages/diplomas/StateDiplomaEditPage';
import { PrivateDiplomaListPage } from './pages/diplomas/PrivateDiplomaListPage';
import { PrivateDiplomaEditPage } from './pages/diplomas/PrivateDiplomaEditPage';
import { VideoLessonListPage } from './pages/video-lessons/VideoLessonListPage';
import { VideoLessonEditPage } from './pages/video-lessons/VideoLessonEditPage';
import { VideoPayoutsPage } from './pages/video-lessons/VideoPayoutsPage';
import ErrorPage from './pages/ErrorPage';

const AppRoutes = () => {
  let routes = useRoutes([
    { path: "/", element: <HomePage /> },
    { path: "admin/:stage?", element: <LoginPage /> },
    { path: "state-degrees", element: <StateDegreeListPage /> },
    { path: "state-degree/edit/:degreeId", element: <StateDegreeEditPage /> },
    { path: "private-degrees", element: <PrivateDegreeListPage /> },
    { path: "private-degree/edit/:degreeId", element: <PrivateDegreeEditPage /> },
    { path: "state-diplomas", element: <StateDiplomaListPage /> },
    { path: "state-diploma/edit/:diplomaId", element: <StateDiplomaEditPage /> },
    { path: "private-diplomas", element: <PrivateDiplomaListPage /> },
    { path: "private-diploma/edit/:diplomaId", element: <PrivateDiplomaEditPage /> },
    { path: "whatsapp-manager", element: <WhatsAppPage /> },
    { path: "tuitions", element: <AdListPage /> },
    { path: "tuitions/new-ads", element: <NewAdsPage /> },
    { path: "tuitions/edit-ads/:adId", element: <AdEditPage /> },
    { path: "payments", element: <PaymentsPage /> },
    { path: "online-classes/weeks", element: <OnlineClassWeeksPage /> },
    { path: "video-lessons", element: <VideoLessonListPage /> },
    // Lesson id 0 creates a new lesson
    { path: "video-lessons/edit/:lessonId", element: <VideoLessonEditPage /> },
    { path: "video-lessons/payouts", element: <VideoPayoutsPage /> },
    { path: "error", element: <ErrorPage/> },
    { path: "*", element: <HomePage /> }
  ]);
  return routes;
};

function App() {

  useEffect(() => {
    if(localStorage.getItem('languageCode') === null) {
      localStorage.setItem('languageCode', "SIN");   
    }    
  });
  
  return (
    <StyleContextProvider>
      <AuthContextProvider>
        <BrowserRouter>          
          <AppRoutes />                   
        </BrowserRouter>
      </AuthContextProvider>      
    </StyleContextProvider> 
  );
}

export default App;
